<div class="configurator-check" [ngClass]="{ 'configurator-check--is-disabled': isDisabled }">
    <div class="checkbox">
        <mg-ui-checkmark [class.isChecked]="isChecked" class="isChecked isSquare"></mg-ui-checkmark>
    </div>
    <button
        (click)="toggleValue()"
        [attr.aria-checked]="isChecked"
        [attr.aria-labelledby]="labelId"
        [class.isChecked]="isChecked"
        role="checkbox"
        type="button"
    >
        <div [id]="labelId" class="label" [innerHTML]="label"></div>
        <div *ngIf="description" class="description">{{ description }}</div>
    </button>
</div>

<mg-ui-modal [keys]="!!modalKeys.length ? modalKeys : [labelId, label]">
    <mat-icon class="configurator-icon-modal">info_outline</mat-icon>
</mg-ui-modal>
